module.exports = __webpack_public_path__ + "static/media/filters--dark.d262a6eb.png";